import PolicyContentPage from "../components/PolicyContentPage";

const AboutUs = () => (
  <PolicyContentPage title="About Us" policyType="aboutUs" />
);

export default AboutUs;
